import React from "react";
import { COLOR_MAP } from "../colorMap";

function FilterPanel({ filters, setFilters, raagData }) {
  const getFilteredData = () => {
    return raagData.filter((r) => {
      const seasonMatch = !filters.Season || r.Season === filters.Season;
      const timeMatch = !filters.Time || r.Time === filters.Time;
      const moodMatch =
        !filters.Mood || (Array.isArray(r.Mood) ? r.Mood.includes(filters.Mood) : r.Mood === filters.Mood);
      return seasonMatch && timeMatch && moodMatch;
    });
  };

  const getUnique = (key, subset) => {
    const values = subset.flatMap((r) => {
      if (Array.isArray(r[key])) return r[key];
      return r[key] ? [r[key]] : [];
    });
    return [...new Set(values)].filter(Boolean);
  };

  const filteredData = getFilteredData();

  const seasonOptions = getUnique("Season", raagData); // Always use full data for Season
  const timeOptions = getUnique("Time", raagData.filter((r) => !filters.Season || r.Season === filters.Season));
  const moodOptions = getUnique("Mood", filteredData);

  const createButtonGroup = (label, key, options) => (
    <div className="mb-4 text-center">
      <div className="mb-1 font-semibold">{label}</div>
      <div className="flex flex-wrap gap-2 justify-center">
        <button
          className={`px-3 py-1 border rounded text-sm ${
            filters[key] === "" ? "bg-gray-300" : "border-gray-300"
          }`}
          onClick={() => setFilters((prev) => ({ ...prev, [key]: "" }))}
        >
          All
        </button>
        {options.map((opt) => {
          const isSelected = filters[key] === opt;
          const bgColor = COLOR_MAP[opt] || "#eee";

          return (
            <button
              key={opt}
              onClick={() => {
                const updated = { ...filters, [key]: opt };
                if (key === "Season") {
                  updated.Time = "";
                  updated.Mood = "";
                } else if (key === "Time") {
                  updated.Mood = "";
                }
                setFilters(updated);
              }}
              style={{
                backgroundColor: bgColor,
                borderColor: isSelected ? "#000" : "#ccc",
                fontWeight: isSelected ? "bold" : "normal",
                boxShadow: isSelected ? "0 0 0 2px #000 inset" : "none",
              }}
              className="px-3 py-1 rounded text-sm border transition-all duration-150"
            >
              {opt}
            </button>
          );
        })}
      </div>
    </div>
  );

  return (
    <div className="w-full space-y-4">
      {createButtonGroup("Season", "Season", seasonOptions)}
      {createButtonGroup("Time of Day", "Time", timeOptions)}
      {createButtonGroup("Mood", "Mood", moodOptions)}
    </div>
  );
}

export default FilterPanel;
